// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ProductMinimumEquipmentModule extends ModuleBase {
  private isOpenMinimum: boolean = false;
  private isOpenRecommended: boolean = false;

  getBackgroundColorFromInstance(instance: object): string {
    let color = "white";

    if (this.currentProduct) {
      color = this.currentProduct.is_van_solution ? "black" : "white";
    }

    if (instance["color"]) {
      color = instance["color"];
    }

    return color;
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get codeGroupedMinimum() {
    if (this.currentProduct) {
      let groups = {};
      this.currentProduct.minimun_equipment.forEach((equipment) => {
        if (!groups[equipment.group]) {
          groups[equipment.group] = [];
        }

        groups[equipment.group].push(equipment);
      });

      let ordered = {};
      Object.keys(groups)
        .sort()
        .forEach((k) => {
          ordered[k] = groups[k];
        });

      return ordered;
    } else {
      return {};
    }
  }

  get codeGroupedRecommended() {
    if (this.currentProduct) {
      let groups = {};
      this.currentProduct.recommended_equipment.forEach((equipment) => {
        if (!groups[equipment.group]) {
          groups[equipment.group] = [];
        }

        groups[equipment.group].push(equipment);
      });

      let ordered = {};
      Object.keys(groups)
        .sort()
        .forEach((k) => {
          ordered[k] = groups[k];
        });

      return ordered;
    } else {
      return {};
    }
  }

  public onToggleOpenMinimum() {
    this.isOpenMinimum = !this.isOpenMinimum;
    if (this.isOpenMinimum) {
      this.isOpenRecommended = false;
    }
  }

  public onToggleOpenRecommended() {
    this.isOpenRecommended = !this.isOpenRecommended;
    if (this.isOpenRecommended) {
      this.isOpenMinimum = false;
    }
  }
}
